import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { PARENT_PARAMS_TYPE, PARENT_TYPE } from 'Pages/partnerProfile'

export const inivateApi = {
	getPartnerNew: async (params: PARENT_PARAMS_TYPE) => {
		const res = await axiosDS().get<PARENT_TYPE>(urls.partnerProfile.partner_new, { params })
		return res.data
	},
}
